import { render, staticRenderFns } from "./Avatar.vue?vue&type=template&id=3d15265b&scoped=true&"
import script from "./Avatar.vue?vue&type=script&lang=ts&"
export * from "./Avatar.vue?vue&type=script&lang=ts&"
import style0 from "./Avatar.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Avatar.vue?vue&type=style&index=1&id=3d15265b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d15265b",
  null
  
)

export default component.exports